import Index from './views/Index'

export default [{
  path: '/partner/:code/onboarding',
  name: 'partner.onboarding',
  component: Index
}]
